module.exports = __webpack_public_path__ + "static/media/instagram.b473fcad.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/assets/instagram.png
// module id = 829
// module chunks = 0